<template>
  <b-modal
    :id="id"
    :ok-title="trans(block === undefined || !!block && !!block.id ? 'save' : 'create')"
    :ok-disabled="!canSave"
    :cancel-title="trans('cancel')"
    size="lg"
    no-enforce-focus
    @shown="onShown"
    @ok="onSave"
  >
    <template #modal-title>
      <span>{{ trans('products') }}</span>
      <small v-if="!!block" class="text-muted ml-2">
        #{{ block.id }}
      </small>
    </template>

    <p>{{ trans('microsite_products_block_about') }}</p>
    <b-form-group :label="trans('product_tags_visible_to_clients')">
      <model-treeselect
        :organization="organization"
        :models="product_tags"
        v-model="client_visible_product_tag_ids"
        :placeholder="trans('tags')"
        :disabled="busy"
      ></model-treeselect>
      <b-form-text>
        {{ trans('microsite_products_client_tags_test') }}
      </b-form-text>
    </b-form-group>

    <b-form-group :label="trans('product_tags_visible_to_admins')">
      <model-treeselect
        :organization="organization"
        :models="product_tags"
        v-model="admin_visible_product_tag_ids"
        :placeholder="trans('tags')"
        :disabled="busy"
      ></model-treeselect>
    </b-form-group>

    <p v-if="isEmpty(client_visible_product_tag_ids) && isEmpty(admin_visible_product_tag_ids)">
      <i class="fa fa-fw fa-info-circle"></i>
      <em>{{ trans('microsite_products_no_visible_tags_warning') }}
      </em>
    </p>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import ModelTreeselect from './../../../common/components/ModelTreeselect'

  // This component can be used to update the tags either for the main
  // products page (block is undefined), or an embedded products block
  // on any page (block is set or null when new)
  export default {
    props: {
      id: {
        type: String,
        default: 'page-products-modal',
      },
      organization: Object,
      page: Object,
      block: Object, // null when new block, undefined when products page
      after: Number,
    },
    components: {
      ModelTreeselect,
    },
    data() {
      return {
        trans: trans,
        isEmpty: _.isEmpty,
        busy: false,
        error: null,
        dirty: false,
        client_visible_product_tag_ids: [],
        admin_visible_product_tag_ids: [],
        product_tags: null,
      }
    },
    computed: {
      canSave() {
        return true
      },
      serialized() {
        if (this.block === undefined) {
          return {
            client_visible_product_tag_ids: this.client_visible_product_tag_ids,
            admin_visible_product_tag_ids: this.admin_visible_product_tag_ids,
          }
        }
        return {
          type: 'products',
          after: this.after,
          meta: {
            client_visible_product_tag_ids: this.client_visible_product_tag_ids,
            admin_visible_product_tag_ids: this.admin_visible_product_tag_ids,
          },
        }
      },
    },
    methods: {
      loadProductTags() {
        if (!!this.product_tags) return
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/tags?type=product`
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.product_tags = response.data
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onShown() {
        this.busy = false
        this.error = null
        if (this.block === undefined) {
          this.admin_visible_product_tag_ids = !!this.organization.amilia_events_settings ?
            this.organization.amilia_events_settings.admin_visible_product_tag_ids
            : []
          this.client_visible_product_tag_ids = !!this.organization.amilia_events_settings ?
            this.organization.amilia_events_settings.client_visible_product_tag_ids
            : []
        } else {
          this.client_visible_product_tag_ids = !!this.block ?
            this.block.meta.client_visible_product_tag_ids :
            []
          this.admin_visible_product_tag_ids = !!this.block ?
            this.block.meta.admin_visible_product_tag_ids :
            []
        }
        this.loadProductTags()
      },
      onSave(e) {
        e.preventDefault()
        this.busy = true
        this.error = null

        let url = this.block === undefined ?
          `/organization/${this.organization.id}/product/quick_settings_update` :
          `/organization/${this.organization.id}/page/${this.page.id}/block`
        if (!!this.block && this.block.id) url += `/${this.block.id}`
        let method = this.block === undefined || !!this.block && this.block.id ?
          'patch' :
          'post'

        axios[method](url, this.serialized)
        .then(response => {
          this.busy = false
          this.$emit('saved', response.data)
          this.$bvModal.hide(this.id)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window[_.camelCase(this.id)] = this
    },
  }
</script>